/**
 * stripeMode.js — single source of truth for "are we in Stripe TEST mode".
 *
 * RC 1.35.F2 Stage-1 P0-1 — gate candidate-facing TEST MODE copy
 * (test-card hint, "no real money will move", "(TEST MODE)" badges)
 * so it ONLY renders when REACT_APP_STRIPE_TEST_MODE is unset or
 * literally `'true'`. Flipping the env var to `'false'` (or omitting
 * it on a production deploy) suppresses every TEST-mode disclosure
 * in one place.
 *
 * Backend `STRIPE_TEST_MODE_ENABLED` remains the source of truth on
 * the Stripe-API side; this helper just makes sure the candidate
 * doesn't see test-mode wording while paying real money.
 */
export function isStripeTestMode() {
  const v = (process.env.REACT_APP_STRIPE_TEST_MODE || 'true').trim().toLowerCase();
  return v !== 'false' && v !== '0' && v !== 'no';
}
